export const urlEncode = value => encodeURIComponent(value);
